module Meevo.Plugins.ClientApp {
  "use strict";
    import ICustomBranding = Meevo.Model.ICustomBranding;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;

    /**
    * Branding Section of ClientApp
    */
    export class BrandingSection extends Meevo.Components.CommonClasses.SettingsSectionBase {

        public customButtonsSet: any;
        public copy: any;
        public fonts: any;
        public auditNoun: Meevo.Model.NounEnum;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected $q: ng.IQService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected basedataService: Meevo.Components.BaseClasses.IDataService,
            protected context: ClientAppContext,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.initializeData();
        }

        initializeData(): void {
            this.auditNoun = Meevo.Model.NounEnum.ClientAppBranding;
            this.getBrandingSettings();

            this.context.setMode(Model.MaintenanceFormState.Readonly);
            this.mode = Model.MaintenanceFormState.Readonly;

            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppBrandingTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        this.copy = angular.copy(this.model);
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_BRANDING + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppBrandingTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        scope.saveBrandingSettings();
                        this.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_BRANDING + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppBrandingTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.model = angular.copy(this.copy);
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_BRANDING + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];
            this.fonts = [
                { value: 'Helvetica, Arial, Tahoma', label: 'Helvetica, Arial, Tahoma' },
                { value: 'Times New Roman, Georgia', label: 'Times New Roman, Georgia' },
                { value: 'Courier New, Monaco', label: 'Courier New, Monaco' },
                { value: 'Impact, Charcoal, sans-serif', label: 'Impact, Charcoal, sans- serif' },
                { value: 'Century Gothic, sans-serif', label: 'Century Gothic, sans-serif' },
                { value: 'Comic Sans MS, cursive, sans-serif', label: 'Comic Sans MS, cursive, sans-serif' }
            ];
        }
     
        getBrandingSettings() {
            this.dataService.customMethodData("api/ClientApp/Branding?includeMetadata=true", "GET", this.model).then((data) => {
                if (data.data) {
                    this.model = data.data;
                    this.loadImagesFromStorage();
                }
            });
        }

        saveBrandingSettings() {
            return this.saveImages()
                .then(() => {
                    return this.dataService.customMethodData("api/ClientApp/ClientAppBranding", "POST", this.model).then((data) => {
                        if (data.data) {
                            //TODO: GET Latest Data OR Refresh current Data With Return data Based on new SP Output
                            this.copy = angular.copy(this.model);
                        }
                    });
                });
        }

        activate(): void {
            super.activate();
            this.loadImagesFromStorage();
        }

        selected(): void {
            super.selected();

            if (this.model
                && this.model.businessLogo
                && this.model.loginScreenBackgroundImage
                && this.model.homeScreenImage) {
                this.loadImagesFromStorage();
            }
        }

        public saveImages(): ng.IPromise<void> {
            this.busyService.start();
            return this.$q.all([
                this.model.businessLogoObj ? this.saveImageToStorage(this.model.businessLogoObj) : this.$q.resolve(null),
                this.model.loginScreenObj ? this.saveImageToStorage(this.model.loginScreenObj) : this.$q.resolve(null),
                this.model.homeScreenObj ? this.saveImageToStorage(this.model.homeScreenObj) : this.$q.resolve(null)
            ]).then((response: Array<IStorageFile | any>) => {
                this.model.businessLogo = this.model.businessLogoObj.fileGuid;
                this.model.loginScreenBackgroundImage = this.model.loginScreenObj.fileGuid;
                this.model.homeScreenImage = this.model.homeScreenObj.fileGuid;
            }).catch(error => {
                this.loggingService.trace(error.statusText);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        protected isImagesLoading: boolean = false;
        loadImagesFromStorage(): void {
            if (this.isImagesLoading) {
                return;
            }
            this.isImagesLoading = true;
            this.busyService.start();
            this.$q.all([
                this.getImageUrl(StorageTypeEnum.ClientAppBusinessLogo, this.model.businessLogo),
                this.getImageUrl(StorageTypeEnum.ClientAppLoginScreen, this.model.loginScreenBackgroundImage),
                this.getImageUrl(StorageTypeEnum.ClientAppHomeScreen, this.model.homeScreenImage)
            ]).then((responses) => {
                let [businessLogoResp, loginScreenResp, homeScreenResp] = responses;
                this.model.businessLogoObj = businessLogoResp.data || {};
                this.model.loginScreenObj = loginScreenResp.data || {};
                this.model.homeScreenObj = homeScreenResp.data || {};
            }).finally(() => {
                this.busyService.stop();
                this.isImagesLoading = false;
            });
        }

        public getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<any> {
            if (!fileGuid) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData(`/api/storage/customBrandingImage/${storageTypeEnum}/${fileGuid}`, 'GET', null);
        }

        /**
         * Save image to storage
         * @param {IStorageFile} file
         * @returns {angular.IPromise}
         */
        public saveImageToStorage(file: IStorageFile = {}): angular.IPromise<any> {
            if (!Object.keys(file).length) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData('/api/storage/customBrandingImage', 'POST', {
                customBrandingImageResource: _.extend(file, { resourceType: file.meevoFile['storageTypeEnum'], contentType: file.contentType })
            });
        }

        /**
        * Select tab
        * @param {ITab} tab
        * */
        public selectTab(prefix: string, tab: number): void {
            if (this.model) {
                let propName: string = prefix + 'Type';
                this.model[propName] = tab;
            }
        }

        /**
        * Set active tab
        * */
        public setActiveTab(prefix: string): number {
            let propName: string = prefix + 'Type';
            return (this.model) ? this.model[propName] : 0;
        }

        public isCOorSingleLocationTenant(): boolean {
            return (this.identityService.inCentralOfficeMode() || this.identityService.isSingleLocation());
        }
        
    }
}